module.exports = {
  'en-ca': require('./en-ca.json'),
  'en-us': require('./en-us.json'),
  'es-ar': require('./es-ar.json'),
  'es-bo': require('./es-bo.json'),
  'es-cl': require('./es-cl.json'),
  'es-co': require('./es-co.json'),
  'es-cr': require('./es-cr.json'),
  'es-ec': require('./es-ec.json'),
  'es-gt': require('./es-gt.json'),
  'es-hn': require('./es-hn.json'),
  'es-mx': require('./es-mx.json'),
  'es-ni': require('./es-ni.json'),
  'es-pa': require('./es-pa.json'),
  'es-pe': require('./es-pe.json'),
  'es-py': require('./es-py.json'),
  'es-sv': require('./es-sv.json'),
  'es-uy': require('./es-uy.json'),
  'fr-ca': require('./fr-ca.json'),
  'pt-br': require('./pt-br.json'),
};
